/** Mirror of `src/shared/localDateTime.ts`, which is the canonical copy. It is duplicated rather than
 *  imported because Turbopack's root is pinned to `web/` (next.config.ts), so nothing outside this
 *  directory resolves at runtime; `tests/contract/webMirrorContracts.test.ts` fails the moment the two
 *  bodies drift. Edit the canonical file first. */

/** Render an ISO 8601 timestamp as an absolute local-time string ('Jun 19, 2026, 14:02').
 *  `seconds` adds the seconds field (tooltips want it; compact lists don't). Falls back to the raw
 *  input when it can't be parsed. Single source of truth for absolute local date/time rendering. */
export function localDateTime(iso: string, locale?: string, seconds = true): string {
  const ms = Date.parse(iso);
  if (!Number.isFinite(ms)) return iso;
  return new Date(ms).toLocaleString(locale, {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit', ...(seconds ? { second: '2-digit' } : {}),
  });
}
